<div class="flex flex-row space-x-4">
  <div [ngClass]="browserControlService.embeddedInXsellerator ? 'w-full p-2 mb-2 pt-3' : 'w-3/5 pt-11 pb-6'">
    <ng-container [ngSwitch]="params.oem">
      <xsr-no-toolbar-menu *ngSwitchCase="'GM'"></xsr-no-toolbar-menu>
      <!-- <svc-ford-dashboard *ngSwitchCase="'FO'"></svc-ford-dashboard>
  <svc-toyota-dashboard *ngSwitchCase="'TOY'"></svc-toyota-dashboard>
  <svc-chrysler-dashboard *ngSwitchCase="'CH'"></svc-chrysler-dashboard>
  <svc-nissan-dashboard *ngSwitchCase="'NIS'"></svc-nissan-dashboard> -->
      <sha-hyundai-menu *ngSwitchCase="'HYU'"></sha-hyundai-menu>
      <svc-toyota-schedule *ngSwitchCase="'TOY'"></svc-toyota-schedule>
      <xsr-no-toolbar-menu *ngSwitchDefault></xsr-no-toolbar-menu>
    </ng-container>
  </div>
  <div class="w-2/5" *ngIf="!browserControlService.embeddedInXsellerator">
    <sha-service-history [serviceHistory$]="serviceLaneFacade.serviceHistory$"
      [openQuoteLines$]="serviceLaneFacade.quoteLines$" sortBy="dateIn" sortDirection="descending">
    </sha-service-history>
  </div>
</div>